module.exports = __webpack_public_path__ + "static/media/file-exclamation.a0f19628.svg";